
<div class="grid">
    <div class="col-12 xl:col-12">
        <div class="card">
            <div class="flex w-full justify-content-between align-items-center">
                <div
                    class="flex w-full justify-content-start align-items-start flex-column"
                >
                    <h4>Vehicle Models</h4>
                    <p-inputGroup class="w-25rem" [formGroup]="searchForm">
                        <input
                            type="text"
                            class=""
                            pInputText
                            (keydown.enter)="searchModelClicked()"
                            (keyup)="searchModelClicked()"
                            formControlName="search"
                            placeholder="Enter model name"
                        />
                        <button
                            type="button"
                            pButton
                            (click)="searchModelClicked()"
                            icon="pi pi-search"
                            class="p-button-secondary"
                        ></button>
                    </p-inputGroup>
                </div>

                <button
                    type="button"
                    pButton
                    (click)="addModelClicked()"
                    class="p-button p-button-primary w-10rem"
                    icon="pi pi-plus"
                    label="Add Vehicle Model"
                ></button>
            </div>
            <div class="spacer"></div>
            <p-table
                [paginator]="true"
                [value]="models"
                [rows]="8"
                responsiveLayout="scroll"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>Model Name</th>
                        <th>Vehicle Make</th>
                        <th>Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-model>
                    <tr>
                        <td>
                            {{ model.name}}
                        </td>
                        <td>
                            {{ model.make.name }}
                        </td>
                        <td>
                            <p-button
                                class="table-button"
                                pTooltip="Edit vehicle model"
                                icon="pi pi-pencil"
                                [rounded]="true"
                                [text]="true"
                                severity="info"
                            />
                            <p-button
                                class="table-button"
                                pTooltip="Delete vehicle model"
                                icon="pi pi-trash"
                                [rounded]="true"
                                [text]="true"
                                severity="danger"
                            />
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
